import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../../../../common/rosetta_formatted_message';
import { getSlideLocation } from '../../../../../utils/slideshow';
import { ChevronRight } from '../../../../common/fa_icons';

const BeginSlideshowButton = (props, context) => (
  <Link to={getSlideLocation(1, context.location)} onClick={props.handleClick}>
    <button className="pill red begin-slideshow">
      <RosettaFormattedMessage parentFilename={__filename}
        id="begin_slideshow"
        description="Button to navigate to first slide"
        defaultMessage="Begin Slideshow {chevron_right}"
        values={{ chevron_right: <ChevronRight /> }}
      />
    </button>
  </Link>
);

BeginSlideshowButton.propTypes = {
  handleClick: PropTypes.func.isRequired
};

BeginSlideshowButton.contextTypes = {
  location: PropTypes.object
};

export default BeginSlideshowButton;
